import * as ActionType from "./coinPackage.type";

const initialState = {
  coinPackage: [],
};

export const coinPackageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_COIN_PACKAGE:
      return {
        ...state,
        coinPackage: action.payload,
      };

    case ActionType.UPDATE_COIN_PACKAGE:
      return {
        ...state,
        coinPackage: state.coinPackage.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
      };

    case ActionType.DELETE_COIN_PACKAGE:
      return {
        ...state,
        coinPackage: state.coinPackage.filter(
          (data) => data._id !== action.payload && data
        ),
      };

    case ActionType.CREATE_COIN_PACKAGE:
      let data = [...state.coinPackage];
      data.unshift(action.payload);
      return {
        ...state,
        coinPackage: data,
      };

    default:
      return state;
  }
};
